var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextsizelarge = function SvgTextsizelarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    "aria-labelledby": "title"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 18.8l-1.1-2.6H3.8l-1 2.6H0l5.5-14h3.1l5.4 14h-2.8zM7.1 7.4L4.6 14h5L7.1 7.4zm14.5 11.4v-1c-.7.9-1.9 1.3-3.2 1.3-1.6 0-3.5-1.2-3.5-3.4 0-2.3 1.9-3.2 3.5-3.2 1.3 0 2.5.4 3.2 1.3v-1.5c0-1.1-1-1.9-2.3-1.9-1.2 0-2.1.4-3 1.3l-.9-1.5C16.6 9 18 8.6 19.7 8.6c2.2 0 4.3.9 4.3 3.7V19h-2.4v-.2zm0-2.3V15c-.4-.7-1.5-1-2.3-1-1.2 0-2.2.8-2.2 1.8s.9 1.8 2.2 1.8c.9-.1 1.9-.4 2.3-1.1z"
  })));
};
export { SvgTextsizelarge as ReactComponent };